import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createImage(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): ImageInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Image, parentId, masterBlockId),
    alignSelf: 'center',
  }
}
